import isEmpty from 'lodash.isempty';
import { PERIOD } from '../../../../constants/shared/CommonConstants';
import { DECODING_SUBSCORE_MEASURES } from '../../../../constants/reading/MeasuresConstants';
import { GRADE } from '../../../../constants/shared/GradesConstants';

const { BOY, MOY, EOY } = PERIOD;
const { FIRST_GRADE, SECOND_GRADE, THIRD_GRADE, FOURTH_GRADE, FIFTH_GRADE, SIXTH_GRADE } = GRADE;

const {
    CVCC_CCVC,
    CCVCC,
    VCE,
    LC,
    IE,
    S2_OS,
    S2_CS,
    S2_VT,
    S2_VCE,
    PREF,
    SUF,
    S2,
    S3,
    S4,
    PREF_SUF,
    S34,
} = DECODING_SUBSCORE_MEASURES;

const SUB_MEASURES_FOR_FOURTH_OR_HIGHER_GRADE = [S34, PREF, SUF, PREF_SUF];

const SUBMEASURES = {
    [FIRST_GRADE]: [CVCC_CCVC, CCVCC, VCE, LC, S2, IE],
    [SECOND_GRADE]: [LC, S2_OS, S2_CS, S2_VT, S2_VCE, SUF, PREF],
    [THIRD_GRADE]: [S2, S3, S4, PREF_SUF, SUF, PREF],
    [FOURTH_GRADE]: SUB_MEASURES_FOR_FOURTH_OR_HIGHER_GRADE,
    [FIFTH_GRADE]: SUB_MEASURES_FOR_FOURTH_OR_HIGHER_GRADE,
    [SIXTH_GRADE]: SUB_MEASURES_FOR_FOURTH_OR_HIGHER_GRADE,
};

const SUBMEASURES_KEY_MAPPER = {
    [BOY]: SUBMEASURES,
    [MOY]: SUBMEASURES,
    [EOY]: SUBMEASURES,
};

const sortSubmeasuresByPeriodAndGrade = (subMeasures, period, grade) =>
    !isEmpty(subMeasures) &&
    SUBMEASURES_KEY_MAPPER[period][grade].reduce((acc, item) => {
        if (!subMeasures[item]) {
            return acc;
        }
        return {
            ...acc,
            [item]: subMeasures[item],
        };
    }, {});

export default sortSubmeasuresByPeriodAndGrade;
